/* eslint-disable @typescript-eslint/no-unused-vars */

import GlobalStyle from 'Components/auth/components/GlobalStyle';
import { wMedium } from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import InfoIconTwo from '../assets/svgIcons/InfoIconTwo';
import InfoIconTwoRed from '../assets/svgIcons/InfoIconTwoRed';

type Props = {
  inputLabel?: string;
  inputPlaceholder: string;
  inputType: string;
  inputName: string;
  inputValue: string;
  inputClassName?: string;
  isPassword?: boolean;
  onInputTogglePassword?: () => void;
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  isDisabled?: boolean;
  autocomplete?: string;
  errorIcon?: boolean;
  maxLength: number;
} & typeof defaultProps;

const defaultProps = {
  inputLabel: '',
  error: '',
  inputClassName: '',
  isPassword: false,
  onInputChange(e: React.ChangeEvent<HTMLInputElement>) { },
  onInputBlur(e: React.ChangeEvent<HTMLInputElement>) { },
  onInputTogglePassword() { },
  autocomplete: 'new-password',
  isDisabled: false,
  errorIcon: false,
};

const InputWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  .error-msg {
    color: #ffa112;
    font-style: italic;
    font-size: 14px;
    text-align: right;
    float: right;
    margin-top: 1px;
    margin-right: 5px;
    font-family: "Roboto_italic";
    font-weight: normal;
  }
  .auth-input.eye_hide + span {
    display: ${(props) => (props.disabled ? 'none' : 'inline-block')};
  }
`;

const InputWithRef = React.forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const {
    inputType,
    inputLabel,
    error,
    onInputChange,
    onInputBlur,
    inputName,
    inputValue,
    inputPlaceholder,
    isDisabled,
    inputClassName,
    isPassword,
    onInputTogglePassword,
    errorIcon,
    maxLength,
  } = props;
  return (
    <div className="input-with-ref-style-wrapper">
      <GlobalStyle />
      <label className="auth-input-label" htmlFor="auth-input">
        {inputLabel}
        {error ? (
          <span className={classNames('error-msg')}>
            {errorIcon ? (
              <>
                <InfoIconTwoRed className="info-icon-red" fillColor="rgba(244, 60, 69, 1)" />
                <span className="text-for-error">{error}</span>
              </>
            ) : error || '* This field is mandatory '}
          </span>
        ) : null}
      </label>
      <InputWrapper disabled={isDisabled}>
        <input
          disabled={isDisabled}
          {...props}
          onChange={(e) => onInputChange(e)}
          id="auth-input"
          className={`auth-input ${inputClassName} ${error ? 'error' : ''} ${isPassword ? 'password' : ''}`}
          name={inputName}
          value={inputValue}
          type={inputType}
          placeholder={inputPlaceholder}
          spellCheck={false}
          onBlur={onInputBlur}
          ref={ref}
          maxLength={maxLength ?? 45}
        />
        <span
          onClick={onInputTogglePassword}
          className={`input-span-hide ${inputType === 'password' ? '' : 'active'}`}
          onKeyPress={onInputTogglePassword}
          role="button"
          aria-label={inputName}
          tabIndex={0}
        >
          <span>{inputName}</span>
        </span>
      </InputWrapper>
    </div>
  );
});

InputWithRef.defaultProps = defaultProps;
export default InputWithRef;
